import { IApplicationState } from '../../types/redux';
import { ITurnInfoSchema } from '../../../shared/repositories/newbuilding-card/entities/house/TurnInfoSchema';

export function getHousesByTurnDisplay(state: IApplicationState): ITurnInfoSchema[] {
  const {
    newbuilding: { housesByTurnDisplay },
  } = state;

  if (housesByTurnDisplay && housesByTurnDisplay.length) {
    return housesByTurnDisplay;
  }

  return [];
}
